module.exports = __webpack_public_path__ + "assets/d9e2905312c9600a506626c1ac640a73.mp3";